import React, { FC } from 'react';
import styled from 'styled-components';
import { PlayerEnum } from '../Player/constants';
import { getFieldColor } from '../../utils/fieldColor';

export interface IField {
  $owner?: PlayerEnum | 'community';
  isEmpty?: boolean;
  $isOver?: boolean;
  isAccessible?: boolean;
  id: number;
  innerRef: any;
}

const StyledField = styled.div<Pick<IField, '$owner' | '$isOver'>>`
  background-color: ${(props) =>
    props.$isOver ? props.theme.field.dropColor : getFieldColor(props.$owner)};
  width: 30px;
  height: 30px;
  border-radius: ${(props) => props.theme.field.borderRadius};
  margin: 20px 10px 10px 10px;
  border: solid black 3px;
`;

const StyledEmptyField = styled.div`
  height: 30px;
  width: 30px;
  margin: 20px 10px 10px 10px;
  border: solid transparent 3px;
`;

type Props = IField & { children: React.ReactNode };

const Field: FC<Props> = (props) => {
  if (props.isEmpty) {
    return <StyledEmptyField />;
  }
  return (
    <StyledField
      ref={props.innerRef}
      $owner={props.$owner}
      $isOver={props.$isOver}
    >
      {props.children}
    </StyledField>
  );
};

export default Field;
